module.exports = __webpack_public_path__ + "img/device-bg2.311ae76c.png";